export const requestInterceptor = (config) => {
    const token = localStorage.getItem('token');
    
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // Add timestamp to prevent caching issues that might cause stale responses
    if (config.method === 'get') {
        config.params = {
            ...config.params,
            _t: Date.now()
        };
    }

    // Ensure proper content type for form data
    if (config.data instanceof FormData) {
        // Let browser set the content-type with boundary for multipart/form-data
        delete config.headers['Content-Type'];
    }

    return config;
};

export const requestErrorInterceptor = (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
};